export default !!navigator.userAgent.match(/(iPad|iPhone|iPod)/g);
